/**
 * Determines the redirect path after successful authentication
 * Checks for pending invite links stored in localStorage
 */
export const getPostAuthRedirect = () => {
  // Check for QR join or other return URL saved before login
  const returnUrl = localStorage.getItem('noyo_return_url');
  if (returnUrl) {
    localStorage.removeItem('noyo_return_url');
    return returnUrl;
  }
  const pendingInvite = localStorage.getItem('pending_invite_link');
  if (pendingInvite) {
    localStorage.removeItem('pending_invite_link');
    return `/invite/${pendingInvite}`;
  }
  const pendingStoryInvite = localStorage.getItem('pending_story_invite');
  if (pendingStoryInvite) {
    localStorage.removeItem('pending_story_invite');
    return `/story-invite/${pendingStoryInvite}`;
  }
  return '/journal';
};
